var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIconSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "url(#paint0_linear_273_727)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7422 18.3836C18.1257 19.0961 17.2444 19.4996 16.3114 19.4996C16.2822 19.4996 16.2529 19.4996 16.2237 19.4989C10.2327 19.3361 5.41244 14.5158 5.25119 8.52555C5.22494 7.5528 5.63445 6.63103 6.37395 5.99503C7.0767 5.38978 7.99169 5.1371 8.88569 5.29685C9.02294 5.3216 9.14069 5.35302 9.24119 5.38602C9.63719 5.51727 9.92519 5.86016 9.99119 6.27866L10.4937 9.46983C10.5567 9.86958 10.4007 10.2747 10.088 10.5282C10.025 10.5792 9.9597 10.6278 9.89145 10.6728C9.71745 10.7913 9.65144 10.9931 9.72944 11.1723C10.4809 12.9011 11.846 14.2661 13.574 15.0176C13.754 15.0963 13.9557 15.0289 14.0772 14.8511C14.1124 14.8001 14.1492 14.7499 14.1867 14.7019C14.4387 14.3809 14.852 14.2263 15.26 14.2915L18.5089 14.8324C18.9379 14.9044 19.2867 15.2082 19.3985 15.6072C19.4187 15.6799 19.4382 15.7624 19.4547 15.8562C19.6115 16.7569 19.352 17.6771 18.7422 18.3836Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_273_727",
    x1: 26.3567,
    y1: -1.66265,
    x2: -4.0077,
    y2: 4.61494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0794952,
    stopColor: "#4D96B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.970165,
    stopColor: "#1F617D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIconSvg);
export default __webpack_public_path__ + "static/media/PhoneIconSvg.737a22318aaaa07050801b7518fb1daf.svg";
export { ForwardRef as ReactComponent };